import React from "react";
import { Typography } from "@mui/material";
import MarkdownRenderer from "./components/MarkdownRenderer";

// Renders a license_agreement row's Markdown body (served by the backend —
// per-company or the default; see license_agreement_service.py). Used by:
//   - License.jsx                 (the post-login acceptance page)
//   - LicenseAgreementDialog.jsx  (read-anytime view from the Reports page)
//   - LicenseAgreements.jsx       (admin editor preview)
// MarkdownRenderer doesn't render raw HTML, so an agreement body can't inject markup.
const LicenseAgreementText = ({ agreement }) => {
  if (!agreement?.body) {
    return (
      <Typography variant="body2" color="text.secondary">
        No license agreement text available.
      </Typography>
    );
  }
  return <MarkdownRenderer>{agreement.body}</MarkdownRenderer>;
};

export default LicenseAgreementText;
